<script setup lang="ts">
import { AccessPageMeta } from '@/access/accessPageMeta'
import InstagramFeedsCard from '@/views/setup/instagram/InstagramFeedsCard.vue'

definePage({ meta: { ...AccessPageMeta.MetaInstagram.Meta, pageTitle: 'Meta Instagram' } })
</script>

<template>
  <VContainer
    fluid
    data-testid="meta-instagram-setup-page"
  >
    <InstagramFeedsCard />
  </VContainer>
</template>
